<template>
  <v-form ref="form" v-model="valid">
    <v-dialog v-model="show" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text>
          {{content}}
          <v-text-field
            v-if="challenge"
            :label="`Type '${challenge}' to confirm.`"
            v-model="challengeConfirmation"
            :rules="[rules.challenge]"
            class="mt-2"
          ></v-text-field>
          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" :disabled="!valid" @click="handleConfirm">Yes</v-btn>
          <v-btn flat color="primary" @click="show=false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
export default {
  name: 'dialog-confirm',
  
  data() {
    return {
      valid: false,
      challengeConfirmation: '',
      rules: {
        challenge: value => value == this.challenge || 'Value does not match.'
      },
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    challenge: String,
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },

  watch: {
    show: function (val, oldVal) {
      if (val) {
        this.challengeConfirmation = null;
        this.$refs.form.reset();
      }
    }
  },  

  methods: {
   
    handleConfirm() {            
      this.$emit('confirm');
      this.show = false;
    }
  }
}
</script>